import React from "react";
import styled from "styled-components";

import { IViewProps, View } from "core/decorators/View";
import { toBlockCss } from "../common/BlockStylesConfig";
import { toTypographyCss } from "../common/TypographyStylesConfig";
import BlockConfig from "./BlockConfig";

interface IBlockProps {
	config: BlockConfig;
}

const StyledBlock = styled.div<IBlockProps>(
	({config}: IBlockProps) => [toBlockCss(config.defaultState), toTypographyCss(config.typography)]
);

export enum BlockVariant {
	DEFAULT = "default",
	JUMBOTRON = "jumbtron",
	MENU = "menu",
	REFINE = "refine",
	PAGING = "paging",
	CARD_HEADER = "card-header",
	CARD_CONTENT = "card-content",
	CARD_ACTIONS = "card-actions"
}

interface IBlockViewProps extends IViewProps<BlockConfig, BlockVariant> {
	className?: string;
	style?: React.CSSProperties;
}

@View({

	id: "block",

	configClass: BlockConfig,

	variants: BlockVariant,

	// work in progress...
	preview: ({config, name}) => {

		return (
			<StyledBlock config={config}>
				{name || "Untitled Variant"}
			</StyledBlock>
		);
	}

})
export class BlockView extends React.PureComponent<IBlockViewProps> {

	public render() {
		return (
			<StyledBlock config={this.props.config} className={this.props.className} style={this.props.style}>
				{this.props.children}
			</StyledBlock>
		);
	}
}



// WEBPACK FOOTER //
// ./src/common/views/block/BlockView.view.tsx